import { useEffect, useState } from "react";
import { GridRowData } from "@mui/x-data-grid";

import Table from "../../components/table";

import { userApi } from "../../api";
import { User } from "../../api/interfaces";

import classes from "./index.module.scss";
import UserRole from "../../components/_modals/UserRole";

const unitsTableColumns = [
  { field: "email", headerName: "Email", type: "string", flex: 1 },
  { field: "uid", headerName: "User ID", sortable: false, width: 200 },
  {
    field: "medicair_id",
    headerName: "MedicAir ID",
    type: "string",
    width: 200,
  },
  {
    field: "business_name",
    headerName: "Business Name",
    type: "string",
    width: 200,
  },
  { field: "role", headerName: "User Role", type: "string", width: 150 },
  { field: "region", headerName: "Region", type: "string", width: 150 },
];

const Users = () => {
  const [roleModalOpen, setRoleModalOpen] = useState<boolean>(false);
  const [selectedUserRow, setSelectedUserRow] = useState<User>();
  const [tableData, setTableData] = useState<GridRowData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getUsers();
  }, []);

  const formatTableData = (items: User[]) => {
    return items.map((el) => {
      return {
        uid: el.uid,
        medicair_id: el.medicair_id,
        email: el.email,
        business_name: el.business_name,
        role: el.role === 0 ? "USER" : "ADMIN",
        region: el.medicair_id && getUserRegion(el.medicair_id),
      };
    });
  };

  const getUsers = async () => {
    setIsLoading(true);
    await userApi.getAllUsers().then((data) => {
      if (data.status < 400) {
        setTableData(formatTableData(data.params.users));
      }

      setIsLoading(false);
    });
  };

  const getUserRegion = (medicair_id: string) => {
    let region = "EU" as "EU" | "US" | "EUS";
    switch (medicair_id.substr(0, 2)) {
      case "eu":
        region = "EU";
        break;
      case "az":
        region = "US";
        break;
      case "ue":
        region = "EUS";
        break;
    }

    return region;
  };

  const handleRowClick = (value: User) => {
    setRoleModalOpen(true);
    setSelectedUserRow(value);
  };

  const handleUserRoleModalClose = async (refreshData?: boolean) => {
    setRoleModalOpen(false);
    refreshData && (await getUsers());
  };

  return (
    <div className={classes.root}>
      <Table
          {...{ isLoading }}
          columns={unitsTableColumns}
          dataSet={tableData}
          showSearch={false}
          onRowClick={handleRowClick}
        />
        {selectedUserRow && (
          <UserRole
            open={roleModalOpen}
            onClose={async (refresh) => handleUserRoleModalClose(refresh)}
            user={selectedUserRow}
          />
        )}
    </div>
  );
};

export default Users;
